import client from './http';

export const createAccount = credentials => client.post('accounts/', credentials);
export const loginUser = credentials => client.post('auth/login/', credentials);
export const logoutUser = () => client.post('auth/logout/');
export const getUsers = () => client.post('auth/users/');



// WEBPACK FOOTER //
// ./src/services/user.js